<template>
  <div>

    <!-- Filtros -->
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="2"
              >
                <v-text-field
                  v-model="filters.startDate"
                  label="Data Início"
                  type="date"
                  outlined
                  dense
                  hide-details
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
              >
                <v-text-field
                  v-model="filters.endDate"
                  label="Data Fim"
                  type="date"
                  outlined
                  dense
                  hide-details
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
              >
                <v-autocomplete
                  v-model="filters.serviceId"
                  :items="services.filter(service => service.id !== 2 && service.id !== 3 && service.id !== 4)"
                  label="Serviço"
                  outlined
                  dense
                  hide-details
                  clearable
                  placeholder="Todos"
                  item-text="name"
                  item-value="id"
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                class="d-flex gap-0"
              >
                <v-btn
                    style="margin-right: 10px;"
                  color="primary"
                  @click="applyFilters"
                >
                  <v-icon left>
                    {{ icons.mdiMagnify }}
                  </v-icon>
                  Buscar
                </v-btn>
                <v-btn
                  color="error"
                  outlined
                  @click="clearFilters"
                >
                  <v-icon left>
                    {{ icons.mdiFilterRemove }}
                  </v-icon>
                  Limpar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tabela -->
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="d-flex align-center justify-space-between">
            <span class="text-lg font-weight-semibold">Campanhas de SMS</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="campaigns"
              :loading="loading"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Itens por página:',
              }"
              class="elevation-0"
              no-data-text="Nenhuma campanha encontrada"
              loading-text="Carregando dados..."
            >
              <!-- Data -->
              <template #item.date="{ item }">
                <div class="d-flex flex-column">
                  <span class="font-weight-medium">{{ formatDate(item.date) }}</span>
                  <span class="text-xs text--secondary">{{ getDayOfWeek(item.date) }}</span>
                </div>
              </template>

              <!-- Total de Campanhas -->
              <template #item.totalCampaigns="{ item }">
                <v-chip
                  small
                  color="primary"
                  outlined
                >
                  {{ item.totalCampaigns }} {{ item.totalCampaigns === 1 ? 'campanha' : 'campanhas' }}
                </v-chip>
              </template>

              <!-- Valor Total -->
              <template #item.totalValue="{ item }">
                <span class="font-weight-semibold text-lg">
                  {{ formatCurrency(item.totalValue) }}
                </span>
              </template>

              <!-- Ações -->
              <template #item.actions="{ item }">
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="viewDetails(item)"
                >
                  <v-icon size="20">
                    {{ icons.mdiMagnify }}
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal de Detalhes com Gráfico de Pizza -->
    <v-dialog
      v-model="detailsDialog"
      max-width="800"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Detalhes do Dia - {{ selectedCampaign && formatDate(selectedCampaign.date) }}
          <v-spacer />
          <v-btn
            icon
            small
            @click="closeDetailsDialog"
          >
            <v-icon color="error">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-row v-if="loadingDetails">
            <v-col
              cols="12"
              class="text-center"
            >
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
              />
              <p class="mt-4">
                Carregando dados...
              </p>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col
              cols="12"
              md="12"
            >
              <v-card
                min-height="400"
                class="pa-3"
                outlined
              >
                <p class="text-center text-md font-weight-semibold mb-4">
                  Distribuição por Status
                </p>
                <vue-apex-charts
                  v-if="pieChartSeries.length > 0"
                  :options="pieChartOptions"
                  :series="pieChartSeries"
                  height="300"
                />
                <div
                  v-else
                  class="text-center pa-8"
                >
                  <v-icon
                    size="48"
                    color="grey lighten-1"
                  >
                    {{ icons.mdiChartPie }}
                  </v-icon>
                  <p class="mt-2 text-grey">
                    Nenhum dado disponível para exibir
                  </p>
                </div>
              </v-card>
            </v-col>

            <!-- Total de Disparos -->
            <v-col
              v-if="pieChartSeries.length > 0"
              cols="12"
            >
              <v-card
              >
                <v-card-text class="text-center py-4">
                  <p class="text-sm mb-1 font-weight-medium">
                    Total de Disparos
                  </p>
                  <h2 class="text-3xl font-weight-bold">
                    {{ getTotalDisparos().toLocaleString('pt-BR') }}
                  </h2>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="closeDetailsDialog"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiMagnify, mdiClose, mdiChartPie, mdiFilterRemove } from '@mdi/js'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ReportsSms',
  components: {
    VueApexCharts,
  },
  data() {
    return {
      icons: {
        mdiMagnify,
        mdiClose,
        mdiChartPie,
        mdiFilterRemove,
      },
      
      loading: false,
      detailsDialog: false,
      loadingDetails: false,
      selectedCampaign: null,
      
      filters: {
        startDate: null,
        endDate: null,
        serviceId: null,
      },
      
      services: [],
      
      // Dados do Gráfico de Pizza
      pieChartSeries: [42150, 2890, 240, 650, 95, 420, 1580, 180],
      pieChartOptions: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        labels: [
          'Entregue',
          'Falhando',
          'Pendentes',
          'Rejeitado',
          'Blacklist',
          'Não Entregável',
          'Resposta',
          'Sem Saldo',
        ],
        colors: ['#4CAF50', '#F44336', '#FF9800', '#9C27B0', '#424242', '#FFA726', '#00BCD4', '#FF5722'],
        legend: {
          position: 'right',
          fontSize: '12px',
          fontWeight: 500,
          formatter: (seriesName, opts) => {
            const value = opts.w.globals.series[opts.seriesIndex]
            return `${seriesName}: ${value.toLocaleString('pt-BR')}`
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            return `${val.toFixed(1)}%`
          },
          style: {
            fontSize: '11px',
            fontWeight: 'bold',
            colors: ['#fff'],
          },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 1,
            opacity: 0.5,
          },
        },
        tooltip: {
          y: {
            formatter: (val, opts) => {
              const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0)
              const percentage = ((val / total) * 100).toFixed(1)
              return `${val.toLocaleString('pt-BR')} SMS (${percentage}%)`
            },
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '14px',
                  fontWeight: 600,
                },
                value: {
                  show: true,
                  fontSize: '20px',
                  fontWeight: 'bold',
                  formatter: val => val.toLocaleString('pt-BR'),
                },
                total: {
                  show: true,
                  label: 'Total',
                  fontSize: '14px',
                  fontWeight: 600,
                  formatter: (w) => {
                    const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                    return total.toLocaleString('pt-BR')
                  },
                },
              },
            },
          },
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
      },
      
      headers: [
        {
          text: 'Data',
          value: 'date',
          sortable: true,
          align: 'start',
        },
        {
          text: 'Total de Campanhas',
          value: 'totalCampaigns',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Valor Total',
          value: 'totalValue',
          sortable: true,
          align: 'start',
        },
        {
          text: 'Ações',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '100',
        },
      ],
      
      campaigns: [
        {
          date: '2025-09-11',
          totalCampaigns: 5,
          totalValue: 4781.50,
          campaignIds: '1,2,3,4,5',
        },
        {
          date: '2025-09-10',
          totalCampaigns: 3,
          totalValue: 2150.00,
          campaignIds: '6,7,8',
        },
        {
          date: '2025-09-09',
          totalCampaigns: 2,
          totalValue: 1890.75,
          campaignIds: '9,10',
        },
      ],
    }
  },
  
  async created() {
    // Carrega lista de serviços
    this.services = await this.getServices()
  },
  
  mounted() {
    this.initializeFilters()
    this.loadCampaigns()
  },
  
  methods: {
    ...mapActions('services', {
      getServices: 'find',
    }),
    ...mapActions('reportServices', {
      getSmsCampaigns: 'getSmsCampaigns',
      getOneSmsCampaigns: 'getOneSmsCampaigns',
    }),
    
    initializeFilters() {
      // Define data início como primeiro dia do mês
      const firstDayOfMonth = dayjs().startOf('month').format('YYYY-MM-DD')
      // Define data fim como último dia do mês
      const lastDayOfMonth = dayjs().endOf('month').format('YYYY-MM-DD')
      
      this.filters.startDate = firstDayOfMonth
      this.filters.endDate = lastDayOfMonth
      
    },
    
    async loadCampaigns() {
      this.loading = true
      try {
        console.log('Carregando campanhas com filtros:', this.filters)
        
        const data = await this.getSmsCampaigns(this.filters)
        
        if (data && data.length > 0) {
          this.campaigns = data
          console.log('Campanhas carregadas:', data.length)
        } else {
          this.campaigns = []
          console.log('Nenhuma campanha encontrada')
        }
      } catch (error) {
        console.error('Erro ao carregar campanhas:', error)
        this.campaigns = []
      } finally {
        this.loading = false
      }
    },
    
    async applyFilters() {
      console.log('🔍 Aplicando filtros:', this.filters)
      await this.loadCampaigns()
    },
    
    clearFilters() {
      console.log('🧹 Limpando filtros')
      this.filters.startDate = null
      this.filters.endDate = null
      this.filters.serviceId = null
      this.initializeFilters()
      this.loadCampaigns()
    },
    
    async viewDetails(item) {
      console.log('🔍 viewDetails chamado para data:', item.date)
      console.log('🔍 Campaign IDs:', item.campaignIds)
      
      this.selectedCampaign = item
      this.detailsDialog = true
      this.loadingDetails = true
      
      try {
        // Busca dados reais das campanhas agrupadas por data
        const statusData = await this.getOneSmsCampaigns(item.campaignIds)
        
        console.log('📊 Status data recebida:', statusData)
        
        if (statusData && statusData.length > 0) {
          // Mapeia os dados para o gráfico
          const statusMap = {
            'Enviado': (statusData.find(d => d.status === 'Enviado') || {}).quantity || 0,
            'Entregue': (statusData.find(d => d.status === 'Entregue') || {}).quantity || 0,
            'Falhando': (statusData.find(d => d.status === 'Falhando') || {}).quantity || 0,
            'Rejeitado': (statusData.find(d => d.status === 'Rejeitado') || {}).quantity || 0,
            'Blacklist': (statusData.find(d => d.status === 'Blacklist') || {}).quantity || 0,
            'Não Entregável': (statusData.find(d => d.status === 'Não Entregável') || {}).quantity || 0,
            'Resposta': (statusData.find(d => d.status === 'Resposta') || {}).quantity || 0,
            'Sem Saldo': (statusData.find(d => d.status === 'Sem Saldo') || {}).quantity || 0,
          }
          
          // Filtra apenas status com valores maiores que 0 para o gráfico
          const seriesData = []
          const labelsData = []
          const colorsData = []
          
          const statusConfig = [
            { key: 'Entregue', color: '#4CAF50' },
            { key: 'Falhando', color: '#F44336' },
            { key: 'Rejeitado', color: '#9C27B0' },
            { key: 'Blacklist', color: '#424242' },
            { key: 'Não Entregável', color: '#FFA726' },
            { key: 'Resposta', color: '#00BCD4' },
            { key: 'Sem Saldo', color: '#FF5722' },
            { key: 'Enviado', color: '#FF9800' },
          ]
          
          statusConfig.forEach(config => {
            const value = statusMap[config.key]
            if (value > 0) {
              seriesData.push(value)
              labelsData.push(config.key)
              colorsData.push(config.color)
            }
          })
          
          // Atualiza o gráfico de pizza
          this.pieChartSeries = seriesData
          this.pieChartOptions = {
            ...this.pieChartOptions,
            labels: labelsData,
            colors: colorsData,
          }
          
          console.log('✅ Gráfico atualizado:', {
            series: this.pieChartSeries,
            labels: labelsData,
            colors: colorsData,
          })
        } else {
          console.log('⚠️ Nenhum dado encontrado para a campanha')
          this.pieChartSeries = []
        }
      } catch (error) {
        console.error('❌ Erro ao carregar detalhes:', error)
        this.pieChartSeries = []
      } finally {
        this.loadingDetails = false
      }
    },
    
    closeDetailsDialog() {
      console.log('🔍 Fechando modal')
      this.detailsDialog = false
      this.selectedCampaign = null
    },
    
    formatDate(dateString) {
      if (!dateString) return '-'
      return dayjs(dateString).format('DD/MM/YYYY')
    },
    
    formatTime(dateString) {
      if (!dateString) return '-'
      return dayjs(dateString).format('HH:mm:ss')
    },
    
    getDayOfWeek(dateString) {
      if (!dateString) return '-'
      const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
      return days[dayjs(dateString).day()]
    },
    
    formatCurrency(value) {
      if (!value) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value)
    },
    
    getTypeColor(type) {
      const colors = {
        'SMS Token': 'secondary',
        'SMS Massive': 'secondary',
        'SMS OTP': 'secondary',
        'SMS Flash': 'secondary',
        'SMS Bet': 'secondary',
        'SMS Shortcode': 'secondary',
      }
      return colors[type] || 'secondary'
    },
    
    getTotalDisparos() {
      // Soma todos os valores do pieChartSeries
      if (this.pieChartSeries && this.pieChartSeries.length > 0) {
        return this.pieChartSeries.reduce((acc, val) => acc + val, 0)
      }
      return 0
    },
  },
}
</script>

<style scoped>
</style>
